import React from 'react';
import { useTranslation } from 'react-i18next';
import PurplePauseIcon from '../../../assets/icons/purple-pause.svg';
import './PausePlayLinkModal.less';

export type PausePlayLinkModalProps = {
  isActive: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const PausePlayLinkModal: React.FC<PausePlayLinkModalProps> = ({ isActive, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onCancel?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  const title = isActive ? t('pause-link-confirm-title') : t('activate-link-confirm-title');
  const description = isActive ? t('pause-link-confirm-desc') : t('activate-link-confirm-desc');

  return (
    <div className="pause-play-link-overlay" onClick={handleOverlayClick}>
      <div className="pause-play-link-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="pause-play-link-container">
          <img src={PurplePauseIcon} className="pause-play-link-icon" alt="Pause/Play" />
          <div className="pause-play-link-title">{title}</div>
          <div className="pause-play-link-desc">{description}</div>
          <button type="button" className="confirm-pause-play-button" onClick={onConfirm}>
            {t('confirm')}
          </button>
          <button type="button" className="confirm-cancel-button" onClick={onCancel}>
            {t('cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PausePlayLinkModal;
